import { render } from "./full-article.vue?vue&type=template&id=2a0adc00&scoped=true"
import script from "./full-article.vue?vue&type=script&lang=js"
export * from "./full-article.vue?vue&type=script&lang=js"

import "./full-article.vue?vue&type=style&index=0&id=2a0adc00&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0adc00"]])

export default __exports__